export const LAYOUT_PAGE_SCROLL_ID = 'layout-page-scroll'

export const scrollLayoutToTop = () => {
    const layout = document.getElementById(LAYOUT_PAGE_SCROLL_ID)
    if(layout) layout.scrollTop = 0
}
